import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=63da08e6"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports